const isLogoUpdating = state => state.SchoolStore.pendingLogo
const isCoverUpdating = state => state.SchoolStore.pendingCover

export { isLogoUpdating, isCoverUpdating }
